import { GET_SER_LI, GET_SER_LI_DATA } from '../constants';
// import PhotoSer from '../models/PhotoSer';
import { updateObject, createReducer } from './common';

export const initialState = { 
    phSCond: {},
    phSN: [],
};

const handler = {
    [GET_SER_LI]: (state, action) => updateObject(state, { phSCond: action.payload, phSN: [] }),
    [GET_SER_LI_DATA]: (state, action) => updateObject(state, { phSN: action.payload })
}

export const photoSerLiReducer = createReducer(initialState, handler);